import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3e63f88d&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e63f88d')) {
      api.createRecord('3e63f88d', component.options)
    } else {
      api.reload('3e63f88d', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3e63f88d&", function () {
      api.rerender('3e63f88d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/platforms_portal/branches/index.vue"
export default component.exports